export default {"src":"/_next/static/media/flutter_logo_f74e3cbc2d.d8ed6409.svg","height":160,"width":320,"blurWidth":0,"blurHeight":0};